"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPersonalEditorialLandingPage = void 0;
var _fetching = require("@ori/fetching");
var _queriesNet = require("../queries-net");
var _utils = require("../utils");
/* istanbul ignore file -- API */

/**
 * Fetch function that fetches data for editorial landing page from GraphQL.
 */
const getPersonalEditorialLandingPage = async ({
  graphQlUrl,
  headers,
  pageId
}) => {
  const data = await (0, _fetching.fetchGraphql)({
    query: _queriesNet.personalEditorialLandingPageQuery,
    url: graphQlUrl,
    variables: {
      pageId
    },
    headers
  });
  const {
    personalEditorialLandingPage
  } = data.application ?? {};
  return {
    application: {
      editorialLandingPage: personalEditorialLandingPage ? {
        ...personalEditorialLandingPage,
        themeItems: (0, _utils.filterOutCurrentCategory)({
          pageId,
          categories: personalEditorialLandingPage.themeItems
        }).map(category => ({
          ...category,
          __typename: 'EditorialLandingPage'
        })),
        __typename: 'EditorialLandingPage'
      } : undefined
    }
  };
};
exports.getPersonalEditorialLandingPage = getPersonalEditorialLandingPage;
